import { UserTimezoneProvider } from '@parkdna/ui/timezone';
import {
  AUTO_TIMEZONE,
  getBrowserTimezone,
} from '@parkdna/ui/TimezoneAutocomplete';
import type { ReactNode } from 'react';

import { useGetCurrentUser } from '@/hooks/queries/organization';

function useCurrentUserTimezone(): string {
  const { user } = useGetCurrentUser();
  const storedTimezone = user?.user_metadata?.timezone as string | undefined;

  if (!storedTimezone || storedTimezone === AUTO_TIMEZONE) {
    return getBrowserTimezone();
  }

  return storedTimezone;
}

export function CurrentUserTimezoneProvider({
  children,
}: {
  children: ReactNode;
}) {
  const timezone = useCurrentUserTimezone();

  return (
    <UserTimezoneProvider timezone={timezone}>{children}</UserTimezoneProvider>
  );
}
